import * as types from './types';
import { loading, error } from 'State/actions';
import { ReportGeneration } from 'Common/ObjectHelper';

export const getOrderList = filtersOptions => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.MANAGE_ORDER_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Order/GetOrderSummary',
        filtersOptions
      );
      dispatch({
        type: types.MANAGE_ORDER_ITEM_LIST,
        payload: response.data.Data,
      });
    } catch (error) {
      dispatch({
        type: types.MANAGE_ORDER_ERROR,
        payload: error,
      });
    } finally {
      dispatch(loading(types.MANAGE_ORDER_LOADING, false));
    }
  };
};

export const getSiteList = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCHING_SITES, true));

    try {
      const response = await MPWWebApi.getGeneric(`Sitemaster`);

      dispatch({
        type: types.MANAGE_ORDER_SITE_LIST,
        payload: response.data.Data ? response.data.Data : [],
      });
      dispatch(loading(types.FETCHING_SITES, false));
    } catch (error) {
      dispatch({
        type: types.FETCH_ALL_SITE_ERROR,
        payload: error,
      });
      dispatch(loading(types.FETCHING_SITES, false));
    }
  };
};

export const manageOrderDelete = id => {
  return (dispatch, getState, MPWWebApi) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(loading(types.MANAGE_ORDER_LOADING, true));
        const response = await MPWWebApi.postGenericInsertUpdate(
          'Order/Delete',
          id
        );
        dispatch(loading(types.MANAGE_ORDER_LOADING, false));
        resolve({
          response,
          error: null,
        });
      } catch (error) {
        dispatch({
          type: types.MANAGE_ORDER_ERROR,
          payload: error,
        });
        dispatch(loading(types.MANAGE_ORDER_LOADING, false));
        reject();
      }
    });
  };
};

export const manageOrderClose = orderListArray => {
  return (dispatch, getState, MPWWebApi) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(loading(types.MANAGE_ORDER_LOADING_ONCLOSE, true));
        const response = await MPWWebApi.postGenericInsertUpdate(
          'Order/ProcessOrCloseOrder/true',
          orderListArray
        );
        resolve({
          response,
          error: null,
        });
        dispatch(loading(types.MANAGE_ORDER_LOADING_ONCLOSE, false));
      } catch (error) {
        dispatch({
          type: types.MANAGE_ORDER_ERROR,
          payload: error,
        });
        dispatch(loading(types.MANAGE_ORDER_LOADING_ONCLOSE, false));
        reject();
      }
    });
  };
};

export const clearOrderGridData = () => {
  return {
    type: types.MANAGE_ORDER_CLEAR_GRID_DATA,
  };
};

export const getPrintManageProcessOrderPreviewData = printRequestData => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PRINT_PREVIEW_PROCESS_ORDER_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Order/GetPrintOrder',
        printRequestData
      );
      if (response.data.Data) {
        const data = response.data.Data;
        if (data) ReportGeneration(data, 'PO Report');
      }
      dispatch(loading(types.PRINT_PREVIEW_PROCESS_ORDER_LOADING, false));
    } catch (err) {
      dispatch(error(types.PRINT_PREVIEW_ERROR, err));
    } finally {
      dispatch(loading(types.PRINT_PREVIEW_PROCESS_ORDER_LOADING, false));
    }
  };
};
export const resetTablePage = payload => {
  return {
    type: types.RESET_TABLE_PAGE_FLAG,
    payload,
  };
};
export const clearAllErrors = () => {
  return {
    type: types.CLEAR_ALL_ERROR,
  };
};
export const setToDateMin = payload => {
  return {
    type: types.SET_TO_DATE_MIN,
    payload,
  };
};
export const setFromDateMax = payload => {
  return {
    type: types.SET_FROM_DATE_MAX,
    payload,
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/state/manageProcessOrder/actions.js